import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { BaseService } from './base.service';
import { LoginResp } from '@app/types/auth.type';

@Injectable({
  providedIn: 'root',
})
export class AuthService extends BaseService {
  login(payload: { email: string; password: string }): Observable<LoginResp> {
    return this.http.post('login', payload).pipe(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      map((resp: any) => {
        if (resp.status) return resp.response;
        this.toastr.error(resp.message ?? 'Error');
        return null;
      }),
    );
  }

  validateToken(token: string): Observable<LoginResp> {
    // return this.http.get(`public/token/validate?token=${token}`).pipe(
    return this.http.get(`public/token/validate`, { params: { token } }).pipe(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      map((resp: any) => {
        if (resp.status) return resp.response;
        this.toastr.error(resp.message ?? 'Error');
        return null;
      }),
    );
  }
}
